function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { QuoteElement } from "../../lib/quote-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { formatCurrency } from "../../lib/utils.js";
import { css, html } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import "../../common/offer-add-button.js";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
import packageOfferStyles from "../../lib/package-offer-styles.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var PetInsurancePackage = /*#__PURE__*/function (_QuoteElement) {
  _inherits(PetInsurancePackage, _QuoteElement);

  var _super = _createSuper(PetInsurancePackage);

  function PetInsurancePackage() {
    var _this;

    _classCallCheck(this, PetInsurancePackage);

    _this = _super.call(this, "pet-insurance");
    _this.annualLimit = 1e4;
    _this.deductibleAmount = 500;
    _this.recommended = false;
    _this.breedSchema = void 0;
    _this.breedNotFound = false;
    return _this;
  }
  /**
   * @ignore
   */


  _createClass(PetInsurancePackage, [{
    key: "policyAttributes",
    get: function get() {
      if (this.breedId) {
        return {
          species: this.species,
          breed_id: this.breedId,
          pet_name: this.petName,
          age: this.age,
          gender: this.gender,
          zip_code: this.customerPostalCode,
          coverage_type: this.plan,
          annual_limit: this.annualLimit,
          deductible_amount: this.deductibleAmount
        };
      }

      return {};
    }
  }, {
    key: "toggleOfferSelection",
    value: function toggleOfferSelection() {
      if (this.selectedState === SelectedState.ACCEPTED) {
        this.selectedState = SelectedState.UNKNOWN;
        this.triggerOfferStateChangeEvent();
      } else {
        this.accept();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.quoteController.render({
        complete: function complete() {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;

          return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        <div id=\"offer-display\" class=", ">\n          ", "\n          <offer-header>\n            ", "\n          </offer-header>\n          <offer-accordion-header @change=", " .checked=", ">\n            ", "\n          </offer-accordion-header>\n          <promotional-description></promotional-description>\n          <section id=\"offer-content\">\n            <peril-list .declined=", "></peril-list>\n            <section id=\"actions\">\n              <offer-add-button \n                @click=", " \n                .selected=", "\n                .addLabel=", "\n                .removeLabel=", "\n              >\n              </offer-add-button>\n            </section>\n          </section>\n          </div>\n    "])), classMap({
            "selected": _this2.selectedState === SelectedState.ACCEPTED
          }), when(_this2.recommended, function () {
            return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div id=\"offer-tag\">Most Popular</div>"])));
          }), ((_b = (_a = _this2.quote) == null ? void 0 : _a.subscription_premium) == null ? void 0 : _b.payment_amount) ? formatCurrency((_d = (_c = _this2.quote) == null ? void 0 : _c.subscription_premium) == null ? void 0 : _d.payment_amount, (_e = _this2.quote) == null ? void 0 : _e.currency) + "/mo" : "", _this2.toggleOfferSelection, _this2.selectedState === SelectedState.ACCEPTED, ((_g = (_f = _this2.quote) == null ? void 0 : _f.subscription_premium) == null ? void 0 : _g.payment_amount) ? formatCurrency((_i = (_h = _this2.quote) == null ? void 0 : _h.subscription_premium) == null ? void 0 : _i.payment_amount, (_j = _this2.quote) == null ? void 0 : _j.currency) + "/mo" : "", _this2.selectedState === SelectedState.DECLINED, _this2.toggleOfferSelection, _this2.selectedState === SelectedState.ACCEPTED, "Select Plan", "Remove Plan");
        }
      });
    }
  }]);

  return PetInsurancePackage;
}(QuoteElement);

PetInsurancePackage.styles = [QuoteElement.styles, packageOfferStyles, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      :host {\n        margin: unset;\n      }\n    "])))];

__decorateClass([property({
  attribute: "species"
})], PetInsurancePackage.prototype, "species", 2);

__decorateClass([property({
  attribute: "plan"
})], PetInsurancePackage.prototype, "plan", 2);

__decorateClass([property({
  attribute: "declared-breed"
})], PetInsurancePackage.prototype, "declaredBreed", 2);

__decorateClass([property({
  attribute: "pet-name"
})], PetInsurancePackage.prototype, "petName", 2);

__decorateClass([property({
  type: Number,
  attribute: "age"
})], PetInsurancePackage.prototype, "age", 2);

__decorateClass([property({
  attribute: "gender"
})], PetInsurancePackage.prototype, "gender", 2);

__decorateClass([property({
  type: Number,
  attribute: "annual-limit"
})], PetInsurancePackage.prototype, "annualLimit", 2);

__decorateClass([property({
  type: Number,
  attribute: "deductible-amount"
})], PetInsurancePackage.prototype, "deductibleAmount", 2);

__decorateClass([property({
  type: Boolean
})], PetInsurancePackage.prototype, "recommended", 2);

__decorateClass([state()], PetInsurancePackage.prototype, "breedSchema", 2);

__decorateClass([property()], PetInsurancePackage.prototype, "breedId", 2);

__decorateClass([state()], PetInsurancePackage.prototype, "breedNotFound", 2);

PetInsurancePackage = __decorateClass([customElement("pet-insurance-plan")], PetInsurancePackage);
export { PetInsurancePackage };